// Validation check fields for DerivedBusinessRole
export const validationCheckFields = [
    { key: 'validation_TemplateBusinessRole', label: 'Template Business Role' },
    { key: 'validation_DifferentiationValue', label: 'Differentiation Value' },
    { key: 'validation_FriendlyName', label: 'Friendly Name' },
    { key: 'validation_Action', label: 'Action' },
    { key: 'validation_ApproversToAdd', label: 'Approvers To Add' },
    { key: 'validation_ApproversToRemove', label: 'Approvers To Remove' },
    { key: 'validation_ActionInsertConflict', label: 'Action Insert Conflict' },
    { key: 'validation_ActionUpdateConflict', label: 'Action Update Conflict' },
    { key: 'validation_PublishInASPConflict', label: 'Publish In ASP Conflict' },
    { key: 'validation_LastFailed', label: 'Last Failed' },
    { key: 'validation_LastFailedError', label: 'Last Failed Error' },
    { key: 'validation_SucceedDate', label: 'Succeed Date' },
    { key: 'validation_Status', label: 'Status' },
]
